export const minInputAmount = 0.00001;
export const outboundAmountMultiplier = 1; // used to calculate amount allowed to bridge
export const DECIMALS_INTERNAL = 6;
export const DECIMALS_SHOW = 6;
export const DECIMALS_SHOW_MOBILE = 2;
export const NATIVE_FEE_DECIMALS_SHOW = 8;
